import React from "react";
import { BsArrowUpCircleFill } from "react-icons/bs";

export default function ArrowTop() {
  return (
    <a href="#app">
      <BsArrowUpCircleFill className="w-1/4 lg:w-auto cursor-pointer text-gray-500 hover:text-black font-bold fixed bottom-4 -right-7 sm:-right-16 lg:right-4 text-3xl" />
    </a>
  );
}
